<template>
  <div
    v-if="isLoading"
    :class="[
      {'cf-section-loader-container': loaderType === 'section'},
      {'cf-page-loader': loaderType === 'page'}
    ]"
  >
    <div class="cf-loader" />
  </div>

  <div v-else>
    <slot />
  </div>
</template>


<script>
  export default {
    name: 'CfLoadingWrapper',

    props: {
      isLoading: {
        type: Boolean,
        default: false
      },

      loaderType: {
        type: String,
        required: true
      }
    }
  };
</script>
